module.exports = __webpack_public_path__ + "static/media/tarja-linhas-corporal.e1741c63.jpg";